import { render, staticRenderFns } from "./spinners-table.vue?vue&type=template&id=48b5659f&"
import script from "./spinners-table.vue?vue&type=script&lang=js&"
export * from "./spinners-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports